/**
 * Безопасные обёртки над Web Storage: приватный режим и заблокированные
 * хранилища бросают синхронно — интерфейс от этого падать не должен.
 */
function safe(getter: () => Storage): Storage | null {
  try {
    const store = getter();
    store.getItem('__sb__');
    return store;
  } catch {
    return null;
  }
}

export const local = {
  get(key: string): string | null {
    return safe(() => window.localStorage)?.getItem(key) ?? null;
  },
  set(key: string, value: string): void {
    safe(() => window.localStorage)?.setItem(key, value);
  },
  remove(key: string): void {
    safe(() => window.localStorage)?.removeItem(key);
  },
  getJson<T>(key: string): T | null {
    const raw = local.get(key);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  },
  setJson(key: string, value: unknown): void {
    local.set(key, JSON.stringify(value));
  },
};

export const session = {
  get(key: string): string | null {
    return safe(() => window.sessionStorage)?.getItem(key) ?? null;
  },
  set(key: string, value: string): void {
    safe(() => window.sessionStorage)?.setItem(key, value);
  },
  remove(key: string): void {
    safe(() => window.sessionStorage)?.removeItem(key);
  },
};
